@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';
@import (reference) '../../../constants/spacing.module.less';

.verify-footer {
  background-color: @scan-page--verify-footer--background-color;
  display: flex;
  justify-content: space-between;
  border-top: 1px solid @scan-page--verify-footer--border-color;
  align-items: center;

  .right {
    display: flex;
    align-items: center;
  }

  .status-count {
    align-items: center;
    flex-wrap: nowrap;
  }

  .verification-status {
    font-size: @space-24;
    padding-left: @space-48;

    .status-badge {
      display: flex;
      align-items: center;

      > svg {
        height: 60px;
        width: 60px;
        transform: scale(0.6);
      }
    }

    .verified {
      background-color: @scan-page--verify-footer--success--background-color;
      padding-right: @space-48;
    }
  }
}

.verified {
  background-color: @scan-page--verify-footer--success--background-color;
  color: @scan-page--verify-footer--text-color;

  > svg {
    fill: @scan-page--verify-footer--icon-color;
  }
}

.auto-confirm {
  height: 90px;
  padding: @space-8;
}
